export default ({ log }) => ({
  periodic: (name, period, fn) => {
    var timer;
    var running = true;
    const ping = () => {
      log.handle("timer:" + name, async () => {
        await fn();
        if (running) {
          timer = setTimeout(ping, period);
        }
      })
    }
    ping();
    return () => {
      running = false;
      clearTimeout(timer);
    }
  }
})


// WEBPACK FOOTER //
// ./src/api/timer-service.js